export default __webpack_public_path__ + "static/media/Tasha_9781846164934.93e3aefc.jpg";